var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['avatar', { avatar_circle: _vm.circle }],style:(_vm.style)},[_c('img',{attrs:{"src":_vm.src,"alt":_vm.alt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }